import React from 'react';
import './index.scss';
import Avatar from '@material-ui/core/Avatar';
import { inject } from 'mobx-react';

import Icon from '@mdi/react'
import { mdiClose} from '@mdi/js'



@inject('translate')
@inject('internal')
export default class CustomAvatar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedFile: null,
            imageUploadId: `image_upload_${Math.floor(Math.random() * 1E6).toString(16)}`,
        }
    }

    file = null;
    photoWasChanged = false

    fileChangedHandler = (event) => {
        this.file = event.target.files[0];
        this.setState({selectedFile: event.target.files[0]})
        this.photoWasChanged = true;
        // this.props.internal.photoWasChanged(true);
    }

    uploadPhoto = () => {
        this.photoWasChanged = true;
        // this.props.internal.photoWasChanged(false);
        this.props.actionUploadPhoto(this.state.selectedFile).then(x => {
            console.log({x})
            this.photoWasChanged = x;
        })
        this.photoWasChanged = false;
        //this.setState({selectedFile: null})

    }

    handleDiscardImage = () => {
        this.setState({selectedFile: null})
        // this.props.internal.photoWasChanged(false);
        this.photoWasChanged = false;
    }

    render() {

        return (
            <div className={'image'}>
                <Avatar
                    alt={this.props.alt || 'avatar'}
                    src={this.state.selectedFile ? URL.createObjectURL(this.state.selectedFile) : this.props.src}
                />
                {this.photoWasChanged ?
                    <span className={'btn-discard-img'} ><Icon path={mdiClose} size={1} onClick={this.handleDiscardImage}/></span>
                    :
                    null
                }
                {this.props.disableEdit ?
                    null
                    :

                   <div className={'image-overlay'}>
                   {this.photoWasChanged ?
                       <div>

                           <span onClick={this.uploadPhoto}>{this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}</span>
                       </div>

                   :
                       <div>
                           <label htmlFor={this.state.imageUploadId} >{this.props.translate.i18n.GLOBAL.BUTTONS.CHANGE}</label>
                           <input
                               type="file"
                               id={this.state.imageUploadId}
                               onChange={this.fileChangedHandler}
                               disabled={this.props.disableEdit}
                               accept={`image/jpg, image/jpeg, image/png${this.props.additionalFileTypes ? `, ${this.props.additionalFileTypes}` : ''}`}
                               />
                       </div>
                   }
                   </div>

                }


                {/* {this.state.selectedFile ?
                    <span className={'btn-discard-img'} ><Icon path={mdiClose} size={1} onClick={this.handleDiscardImage}/></span>
                    :
                    null
                }
                <div className={'image-overlay'}>
                {this.state.selectedFile ?
                    <div>

                        <span onClick={this.uploadPhoto}>{this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}</span>
                    </div>

                :
                    <div>
                        <label htmlFor="image_upload" >{this.props.translate.i18n.GLOBAL.BUTTONS.CHANGE}</label>
                        <input
                            type="file"
                            id="image_upload"
                            onChange={this.fileChangedHandler}
                            disabled={this.props.disableEdit}/>
                    </div>
                }

                </div>*/}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/basic/customAvatar/index.js